import axios from "axios";

export const api = (token) =>
    axios.create({
        baseURL: "https://4p106htdlf.execute-api.eu-west-2.amazonaws.com/dev",
        timeout: 19000,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    });

export const contact = (data) => api(undefined).post("/mailer", data).then(data => data.data);